export default __webpack_public_path__ + "static/media/sofya.c3b9eb46.jpg";